import { render, staticRenderFns } from "./ServiceTypes.vue?vue&type=template&id=68e596b7&scoped=true&"
import script from "./ServiceTypes.vue?vue&type=script&lang=js&"
export * from "./ServiceTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e596b7",
  null
  
)

export default component.exports